import {User} from "./User";
import {Withdrawal} from "../interface/Withdrawal.interface";
import {UserProject} from "../interface/UserProject.interface";
import {CURRENCY} from "../utils/constant";

export class Project {
    uuid?: string
    _id?: string
    participants?: number
    name: string
    currency: string
    description?: string
    status: string
    startDate: Date
    endDate: Date
    dueDay: number
    penaltyRate?: number
    penaltyAmountPerDay: number
    penaltyPerDay: number
    activated?: boolean
    contribution: number
    cashFundAmount: number
    withdrawalAmount: number
    withdrawalDay: number
    share: number = 0
    Users: User[]
    UserProject?: UserProject
    Withdrawals?: Withdrawal[]


    constructor(params: {
        uuid?: string,
        participants?: number,
        name: string,
        description?: string,
        startDate: Date,
        endDate: Date,
        dueDay?: number,
        status: string,
        currency: string,
        penaltyPerDay?: number,
        cashFundAmount?: number
        penaltyAmountPerDay?: number,
        activated?: boolean,
        contribution: number,
        withdrawalAmount?: number,
        withdrawalDay?: number,
        share?: number,
        Users?: User[],
        UserProject?: UserProject,
        Withdrawals?: Withdrawal[],
    }) {
        this.name = params.name;
        this.description = params.description;
        this.status = params.status;
        this.currency = params.currency;
        this.participants = params.participants ?? params.Users?.length ?? 0;
        this.startDate = new Date(params.startDate);
        this.penaltyPerDay = params.penaltyPerDay || 0;
        this.cashFundAmount = params.cashFundAmount || 0;
        this.uuid = params.uuid;
        this.endDate = new Date(params.endDate)
        this.dueDay = params.dueDay || 1
        this.penaltyAmountPerDay = params.penaltyAmountPerDay || 0
        this.activated = params.activated
        this.contribution = params.contribution
        this.share = params.share || 0
        this.withdrawalAmount = params.withdrawalAmount || 0
        this.withdrawalDay = params.withdrawalDay || 1
        this.UserProject = params.UserProject || undefined
        this.Withdrawals = params.Withdrawals?.map((it) => ({...it, date: new Date(it.date)})) || []
        this.Users = params.Users?.map(it => new User({...it, role: it.role!, defaultProject: new Project(this)})) || []

    }

    getCurrencySymbol() {
        return CURRENCY.filter((c) => c.label === this.currency)[0].symbol
    }

    /**
     * Get the project ID (uuid or fallback to _id)
     * This method provides a consistent way to get the project identifier
     */
    getProjectId(): string {
        return this.uuid ?? this._id ?? "";
    }

}